import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

function About() {
  return (
    <div id="top">
      <div id="wrapper">
        <Header />
        <div id="navig_inside">
          <Navigation />
        </div>
        <div id="banner"></div>
        <div id="inside_page" className="bodyText">
          <p className="welcome_heading">From the Principals Desk............</p>
          <div id="Coloum2_a">
            <p>As you may be aware, our polytechnic started functioning in the year 1997 as the first and only private Women's Polytechnic in the entire undivided Dakshina Kannada district. Due to popular demand from the parents for admission of boys, it was subsequently converted into a co-ed polytechnic in the year 1999. Indira Shiva Rao Polytechnic is a unit of Sri Krishna Shikshana Prathisthana Trust, Krishnapur Mutt, Udupi, which is ably presided by his holiness Sri Sri Vidyasagara Theertha pontiff of Sri Krishnapur Mutt, Udupi, who is the visionary behind starting this polytechnic.<br />
              <br />
              With the past 27 years of fruitful and dedicated service, Indira Shiva Rao Polytechnic has blossomed into an Institution par excellence and is striving hard to play a significant role in developing well trained and disciplined human resource to serve the nation in the Engineering and Technology segment of our Economy.</p>
          </div>
          <div id="Coloum2_b">
            <img src="/images/PRINCIPAL PHOTO-1(1).jpg" width="250" height="103" alt="Principal" />
          </div>
          <div className="clear"></div>
          <div id="page1">
            <span className="bodyText">
              <p> &nbsp;We are fully aware that the reputation and the success earned over the bygone years is not by any magic, but earned in a hard way, owing to the undeterred commitment of the Trustees of Sri Krishna Shikshana Prathisthana Trust, members of the Governing council of the college and the wholehearted support and contributions of our staff members. <br />
                <br />
                Right from the year of Inception, the Management laid great emphasis on building of character and discipline in students in addition to imparting knowledge &amp; skills in Engineering and Technology, with the aim of developing them into wholesome personalities. <br />
                <br />
                This always has left us with a humble feeling that we are instrumental in giving the best citizens and Engineers to our society and the country at large.<br />
                <br />
                It is a fact that Rapid Technical advances and Industrial growth has put tremendous pressure on the Institutions of higher learning like ours, which has called for a close interaction of the institute with the Industries on one end and the monitering bodies [Department of Technical Education, Karnataka and All India Council for Technical Education, New Delhi] in meeting the increasing demand for well trained and disciplined Engineers.<br />
                <br />
                Accordingly, and in view of extending the vision of establishing an excellent, integrated campus for technical education in Udupi district, the polytechnic has been now shifted to spacious (10.75 acre) campus behind "Rajathadri" (New D.C.Office), at Manipal, and the academic activities for the year 2019-20 have been started at the new campus from 01.07.2019.<br />
                <br />
                We at Indira Shiva Rao Polytechnic as in the past are always ready to accept all oncoming challenges in the year to come and continue to excel in delivering quality education to our students, there by fulfilling our obligation to the national development.</p>
              <p className="Signleft">Udupi<br />
              </p>
              <p className="SignRight"><span className="hWords">Mr.Srinath Nayak</span><br />
                Principal</p>
            </span>
            <br />
            <br />
            <br />
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default About;
